export default "__VITE_ASSET__be4a7f91__"